import { render, staticRenderFns } from "./RosterFormRecord.vue?vue&type=template&id=485b49ee&"
import script from "./RosterFormRecord.vue?vue&type=script&lang=js&"
export * from "./RosterFormRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485b49ee')) {
      api.createRecord('485b49ee', component.options)
    } else {
      api.reload('485b49ee', component.options)
    }
    module.hot.accept("./RosterFormRecord.vue?vue&type=template&id=485b49ee&", function () {
      api.rerender('485b49ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Roster/RosterFormRecord/RosterFormRecord.vue"
export default component.exports